import React from "react"
import "./EudractArms.scss"
import { v4 as uuidv4 } from "uuid"
import { ARM_TYPES } from "../../../../../../RJS/schemas/dataSchemas/enum/enum"

const EudractArms = ({ arms, schema, view }) => {
  const displayProducts = (arm) => {
    return (
      <div style={{ marginTop: 12, marginLeft: 12 }}>
        {arm.products.map((product, i) => (
          <div key={uuidv4()}>
            <div
              className="eudract-arms-title"
              style={{ marginBottom: 8 }}
            >
              {i + 1}. Product
            </div>
            {Object.keys(schema.properties[view].properties.products.properties).map((key) => {
              let value = product[key]

              if (
                (key === "pharmaceutical_forms" || key === "routes_of_administration") &&
                value &&
                Array.isArray(value)
              ) {
                value = product[key].join(", ")
              }
              return (
                <div
                  className="eudract-property-container"
                  key={uuidv4()}
                >
                  <div className="eudract-property-title ">
                    {schema.properties[view].properties.products.properties[key].title}
                  </div>
                  <div className="eudract-property-value">{value}</div>
                </div>
              )
            })}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="eudract-container">
      <div className="eudract-title">Arms</div>
      {arms.map((arm, i) => (
        <div
          className="eduract-arms-container"
          key={uuidv4()}
        >
          <div className="eudract-arms-title">{i + 1}. Arm</div>
          {Object.keys(schema.properties[view].properties.arms.properties)
            .filter((key) => key !== "joined_reason_details")
            .map((key) => {
              let val = ""
              if (typeof arm[key] === "string") val = arm[key]

              if (key === "type") {
                const foundItem = ARM_TYPES.find((item) => item.value === val)
                if (foundItem?.registries?.[view]) {
                  val = foundItem.registries[view]
                }
              }

              return (
                <div
                  className="eudract-property-container"
                  key={uuidv4()}
                >
                  <div
                    className="eudract-property-title"
                    style={key === "products" ? { borderRight: "0px solid #000" } : {}}
                  >
                    {schema.properties[view].properties.arms.properties[key].title}
                  </div>
                  <div className="eudract-property-value">{val}</div>
                </div>
              )
            })}
          {arm.products && displayProducts(arm)}
        </div>
      ))}
    </div>
  )
}

export default EudractArms
